(function ($, window) {

	let win = $(window);

	win.on("load", () => {

		// try get the images
		let containers = $(
			'.featured-img,' +
			'.card .img-wrapper'
		);

		// leave if nothing
		if (containers.length < 1) return;

		// do resize on load
		containers.each(function () {
			resizeImage($(this));
		});

		// execute once after screen resize
		win.on('resize.resizeImage', $.debounce(250, () => {
			containers.each(function () {
				resizeImage($(this));
			});
		}));

	});

	function resizeImage(container) {

		// get the image
		let image = container.find('img');

		// leave if nothing
		if (image.length < 1) return;

		// get the height and width of image and container
		let containerW = container.width(); // Max width for the image
		let containerH = container.height();    // Max height for the image
		let imageW = image.width();    // Current image width
		let imageH = image.height();  // Current image height

		// make sure the container doesnt change
		container.css({
			'width':containerW,
			'height':containerH,
		});

		// if the image is longer than container, lock the height and overflow the width
		if (imageH < containerH && imageH !== null) {
			image.addClass('lock-height');
		}

		// if the image is taller than container, lock the width and overflow the height
		if (imageW < containerW) {
			image.removeClass('lock-height');
		}
	}

})(jQuery, window);